import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { useMantineTheme, NumberInput as NumberInput$1 } from '@mantine/core';
import { useInputStyle, useInputDynamicStyle } from './Input.style.js';
import { GUI_GLOBAL_CLASS, GUI_COMP_CSS_VARIABLE_CLASS } from '../../utils/index.js';

var _excluded = ["fz", "fw", "type", "invalid", "size", "styles", "className", "classNames", "breakpoints", "isH5MappingAppStyle", "applyColorVariable"];
var NumberInput = function NumberInput(props) {
  var theme = useMantineTheme();
  var fz = props.fz,
    fw = props.fw,
    _props$type = props.type,
    type = _props$type === void 0 ? 'outlined' : _props$type,
    invalid = props.invalid,
    _props$size = props.size,
    size = _props$size === void 0 ? 'md' : _props$size,
    _props$styles = props.styles,
    styles = _props$styles === void 0 ? {} : _props$styles,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    classNames = props.classNames,
    _props$breakpoints = props.breakpoints,
    breakpoints = _props$breakpoints === void 0 ? [] : _props$breakpoints,
    _props$isH5MappingApp = props.isH5MappingAppStyle,
    isH5MappingAppStyle = _props$isH5MappingApp === void 0 ? theme.other.isH5MappingAppStyle : _props$isH5MappingApp,
    _props$applyColorVari = props.applyColorVariable,
    applyColorVariable = _props$applyColorVari === void 0 ? false : _props$applyColorVari,
    restProps = _objectWithoutProperties(props, _excluded);
  var _useInputStyle = useInputStyle({
      type: type,
      size: size,
      hasLeft: false,
      hasRight: false,
      hasClear: false,
      isH5MappingAppStyle: isH5MappingAppStyle,
      breakpoints: breakpoints
    }, {
      classNames: classNames,
      styles: styles,
      name: 'GateNumberInput'
    }),
    cx = _useInputStyle.cx,
    classes = _useInputStyle.classes;
  return /*#__PURE__*/React__default.createElement(NumberInput$1, _objectSpread2(_objectSpread2({
    hideControls: true,
    error: invalid
  }, restProps), {}, {
    style: _objectSpread2(_objectSpread2({}, useInputDynamicStyle({
      fz: fz,
      fw: fw
    })), restProps.style),
    classNames: classes,
    className: cx(className, GUI_GLOBAL_CLASS, applyColorVariable ? GUI_COMP_CSS_VARIABLE_CLASS : undefined)
  }));
};

export { NumberInput };
//# sourceMappingURL=NumberInput.js.map
